import React from "react";
import "./Footer.css";
import mapleAnimation from "../assets/lottie/canadian-maple-leaf.json";
import Lottie from "lottie-react";

const Footer = () => {

  return (
    <section className="footer">
      <div className="container-footer max-970">
        <div className="footer-content">
          <div id="w-node-c167c85f-381b-f310-181b-370e6e9d71be-bffc82c9">
            <div className="footer-block logo-text-footer">
              <a href="https://prep2pass.ca/" >
              
                {/* Lottie Animation */}
                {/* <div className="w-[105px] h-[110px] flex items-center justify-center"> */}
                {/* <div className="lottie-animation-11"> */}
                  <Lottie
                    animationData={mapleAnimation}
                    loop={true}
                    autoplay={true}
                    style={{ height: 100, width: 100 }}
                    // className="lottie-animation-11"
                  />
                {/* </div> */}
              </a>
              <div className="title-small-prep">
                <strong className="bold-text-7 footer-heading logo-heading">
                  prep
                </strong>
                <span className="text-span-4">
                  <strong className="bold-text-7 footer-heading logo-heading letter2">
                    2
                  </strong>
                </span>
                <strong className="bold-text-7 footer-heading logo-heading">
                  Pass
                </strong>
              </div>
            </div>
            <p className="paragraph-26">
              Helping newcomers succeed in the TCF <br />
              Canada speaking exam.
            </p>
          </div>
          <div
            id="w-node-_4b528125-22a2-fff2-e522-7f3bbffc82d3-bffc82c9"
            className="footer-block mobile"
          >
            <div className="title-small">
              <strong className="bold-text-7 footer-heading">
                Quick Links
              </strong>
            </div>
            <a href="https://prep2pass.ca/#how-that-works" className="footer-link">
              How it Works
            </a>
            <a href="/plans" className="footer-link">
              Pricing
            </a>
            <a href="https://prep2pass.ca/#faq" className="footer-link">
              FAQ
            </a>
            <a href="https://prep2pass.ca/exam-explanation" className="footer-link">
              Exam Format
            </a>
          </div>
          <div
            id="w-node-_4b528125-22a2-fff2-e522-7f3bbffc82e8-bffc82c9"
            className="footer-block mobile"
          >
            <div className="title-small">
              <strong className="bold-text-5 footer-heading">Contact</strong>
              <br />
            </div>
            <div className="div-block-39">
              <div className="text">Email:</div>
              <a
                href="https://outlook.live.com/mail/0/deeplink/compose?mailtouri=mailto%3Asupport%40prep2pass.ca"
                className="footer-link mail-contect" style={{color: '#1c1f26'}}
              >
                support@prep2pass.ca
              </a>
            </div>
            <div className="madein"><div className="text-block-34">Made in Canada </div>
            <img src="https://cdn.prod.website-files.com/684385981705295b568a32e7/688c5856b74269d7d5bd7f7c_canada.svg" loading="lazy" alt="" className="image-22"/>
            </div>
            <div className="div-block-25">
              <a href="#" className="w-inline-block">
                <img
                  src="https://cdn.prod.website-files.com/684385981705295b568a32e7/688c83ab2ca1858dffad68fe_Link.svg"
                  loading="lazy"
                  width="Auto"
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
        <div className="footer-divider divder-sec"></div>
        <div className="w-layout-blockcontainer copy-right w-container">
          <div className="div-block-24">
            <div className="div-block-36">
              <div className="footer-copyright-center">© 2025 Prep2Pass</div>
              <p className="paragraph-36">• All rights reserved&nbsp;</p>
              <a href="https://prep2pass.ca/legal-page" className="footer-link _2">
                • Terms &amp; Privacy
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
